export const roundIfNumeric = (value) => {
    if (!value) {
        return value;
    }
    const num = Number(value);
    return isNaN(num) ? value : Math.round(num);
};
export const setParamIfDefined = (url, key, value, deleteExisting, roundValue) => {
    if (value) {
        if (roundValue) {
            value = roundIfNumeric(value);
        }
        url.searchParams.set(key, value.toString());
    }
    else if (deleteExisting) {
        url.searchParams.delete(key);
    }
};
export const setParamIfUndefined = (url, key, value) => {
    if (!url.searchParams.has(key)) {
        url.searchParams.set(key, value.toString());
    }
};
export const getNumericParam = (url, key) => {
    const value = Number(url.searchParams.get(key));
    return isNaN(value) ? undefined : value;
};
/**
 * Given a URL object, returns path and query params
 */
export const toRelativeUrl = (url) => {
    const { pathname, search } = url;
    return `${pathname}${search}`;
};
/**
 * Returns a URL string that may be relative or absolute
 */
export const toCanonicalUrlString = (url) => {
    return url.hostname === "n" ? toRelativeUrl(url) : url.toString();
};
/**
 * Normalises a URL object or string URL to a URL object.
 */
export const toUrl = (url, base) => {
    return typeof url === "string" ? new URL(url, base ?? "http://n/") : url;
};
